import { DO_NOT_USE_FaWrapper } from '../../../../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons/faCircleCheck';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons/faTriangleExclamation';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo';
import { faCircleXmark } from '@fortawesome/pro-regular-svg-icons/faCircleXmark';
import { jsx } from 'react/jsx-runtime';

function getIcon(appearance, lightMode) {
  var _jsx2, _jsx3, _jsx4, _jsx5, _jsx6;
  switch (appearance) {
    // deprecated use danger
    case 'destructive':
    case 'danger':
      return /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx2 = {
        icon: "circle-xmark",
        $color: lightMode ? 'red.500' : 'red.400',
        $size: 24
      }, _jsx2["icon"] = faCircleXmark, _jsx2));
    case 'info':
      return /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx3 = {
        icon: "circle-info",
        $color: lightMode ? 'blue.500' : 'blue.400',
        $size: 24
      }, _jsx3["icon"] = faCircleInfo, _jsx3));
    case 'warning':
      return /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx4 = {
        icon: "triangle-exclamation",
        $color: lightMode ? 'yellow.500' : 'yellow.400',
        $size: 24
      }, _jsx4["icon"] = faTriangleExclamation, _jsx4));
    case 'success':
      return /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx5 = {
        icon: "circle-check",
        $color: lightMode ? 'green.500' : 'green.400',
        $size: 24
      }, _jsx5["icon"] = faCircleCheck, _jsx5));
    case 'primary':
    default:
      return /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx6 = {
        icon: "circle-info",
        $color: lightMode ? 'brandPrimary.500' : 'brandPrimary.50',
        $size: 24
      }, _jsx6["icon"] = faCircleInfo, _jsx6));
  }
}

export { getIcon };
